import { AxiosResponse } from 'axios'
import sendRequest from 'utils/sendRequest'
import { IArtist, INetwork, IPage, IStatusData, IWhitelist } from './type'

const URL = process.env.REACT_APP_API_BACKEND_URL + '/admin/'

export function getNameOfStatus(status?: IStatusData) {
  switch (status) {
    case IStatusData.PENDING:
      return 'PENDING_REQUEST'
    case IStatusData.APPROVED:
      return 'APPROVED'
    case IStatusData.DISAPPROVED:
      return 'DISAPPROVED'
    default:
      return undefined
  }
}

export function getNetwork(): Promise<Array<INetwork> | undefined> {
  return sendRequest({
    url: process.env.REACT_APP_API_BACKEND_URL + '/networks',
    method: 'GET',
  })
}

/* ===== */

export async function getAllWhitelist({
  page,
  limit,
  status,
}: {
  page?: number
  limit?: number
  status?: IStatusData
}): Promise<AxiosResponse<IPage<Array<IWhitelist>> | undefined>> {
  const params = { page, limit, status }
  return sendRequest(
    {
      url: URL + 'get-all-whitelist',
      method: 'GET',
      params,
    },
    true
  )
}

export async function updateStatusWhitelist({
  address,
  status,
  networkId,
}: {
  address: string
  status: IStatusData
  networkId: number
}): Promise<AxiosResponse<undefined>> {
  return sendRequest(
    {
      url: URL + 'change-status-whitelist',
      method: 'POST',
      // TODO: Bảo Phương bỏ qua update networkId
      data: { address, status, networkId },
    },
    true
  )
}

/* ====== */

export async function getAllArtist({
  page,
  limit,
  status,
}: {
  page: number
  limit: number
  status?: IStatusData
}): Promise<AxiosResponse<IPage<Array<IArtist>> | undefined>> {
  const params = { page, limit, status }
  return sendRequest(
    {
      url: URL + 'get-all-artist',
      method: 'GET',
      params,
    },
    true
  )
}

export async function updateStatusArtist({
  address,
  status,
}: {
  address: string
  status: IStatusData
}) {
  return sendRequest({
    url: URL + 'change-status-artist',
    method: 'POST',
    data: { address, status },
  })
}

export async function updateStatusArray({
  ids,
}: {
  ids: Array<number>
}): Promise<AxiosResponse<undefined>> {
  return sendRequest(
    {
      url: URL + 'change-status-array',
      method: 'POST',
      data: { ids },
    },
    true
  )
}
